<template>
  <div class="mx-auto my-5">
    <b-modal ref="modalUnconfirmed" title="Attention:" @cancel="resendEmail">
      <div class="d-block text-center">
        <p>用户帐户尚未激活。请检查您的收件箱以获取确认邮件</p>
      </div>
      <div slot="modal-cancel">
        重发确认邮件
      </div>
    </b-modal>
    <div class="account-wall mb-3">
      <h1 class="text-center login-title" v-if="isShow">登录</h1>
      <b-form class="form-login" ref="ruleForm" v-if="isShow">
        <b-form-input v-model="email" type="email" v-validate="'required|email'" 
          :class="{'form-control': true, 'is-invalid': errors.has('email'), 'mb-3':true}" 
          name="email" placeholder="邮箱">
        </b-form-input>
        <b-form-input v-model="password" type="password" placeholder="密码"
          name="password" v-validate="'required|alpha_dash'" 
          :class="{'form-control':true, 'is-invalid':errors.has('password'), 'mb-4':true}">
        </b-form-input>
        <b-button size="lg" variant="primary" type="submit" @click.prevent="login" :loading="logining" block>
            登录</b-button>
        <b-form-checkbox class="mt-2 float-left" v-model="rememberMe" plain> 记住我 </b-form-checkbox> 
        <router-link to="/forget" class="mt-2 float-right">忘记密码?</router-link><span class="clearfix"></span>
      </b-form>
    <router-link to="/register" class="text-center new-account">没有账号？立即注册 </router-link>
    </div>
    <b-alert v-show="errors.has('email')" show variant="warning">{{ errors.first('email') }}</b-alert>
    <b-alert v-show="errors.has('password')" show variant="warning">{{ errors.first('password') }}</b-alert>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: '',
      logining: false,
      rememberMe: false,
      fetchUser: false,
      isShow: true
    }
  },

  methods: {
    login () {
      console.log('hha')
      this.$validator.validateAll()
      .then(result => {
        if (!result) {
          return
        }
        let redirect = this.$auth.redirect()
        this.$auth.login({
          data: {
            email: this.email,
            password: this.password
          },
          rememberMe: this.rememberMe,
          redirect: redirect ? redirect.from.name : '/',
          fetchUser: this.fetchUser
        })
        .then((res) => {
          // FIXME: ElementUI is required to use $message, need to find a replacement
          console.log(this.$auth)
          this.$message(res.data.message)
        })
        .catch((error) => {
          if (error.response.data.status === 'unconfirmed') {
            this.$refs.modalUnconfirmed.show()
          } else {
            this.$message(error.response.data.message)
          }
        })
      })
    },

    resendEmail () {
      this.$http.post('/user/send_confirmation_email/' + this.email)
      .then(res => {
        alert(res.data.message)
      })
    },

    greet: function (e) {
      this.isShow = !this.isShow
    }
  },

  mounted () {
    console.log(this.$auth.redirect())
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
